import React from "react";
import { Button } from "react-bootstrap";

const DeleteAccountManagementModel = () => {
  return (
    <>
      <div className="profile-common-title">
        {" "}
        <h3>Archive My Account </h3>
      </div>
      <div className="profile-common">
        <div className="deleteaccount-profile-main d-flex align-items-center justify-content-between ">
          <div className="deleteaccount-profile">
            <p>
              Are you sure you want to archive your account? Archiving will
              deactivate your access and hide your profile from view. You can
              reactivate anytime by contacting support. Proceed with archiving?
            </p>
          </div>
          <Button
            className="lightred-btn  deleteaccount-profile-btn "
            // onClick={(e) =>}
              title="Archive My Account"
          >
            Archive My Account
          </Button>
        </div>
      </div>
      <div className="profile-common-title">
        {" "}
        <h3>Delete Account</h3>
      </div>
      <div className="profile-common">
        <div className="deleteaccount-profile-main d-flex align-items-center justify-content-between ">
          <div className="deleteaccount-profile">
            <p>
              Are you sure you want to delete your account? Deleting your
              account is permanent. All data, preferences, and history will be
              erased and cannot be recovered. To confirm, please re-enter your
              username and password before proceeding with deletion.
            </p>
          </div>
          <Button
            className="lightred-btn  deleteaccount-profile-btn "
            // onClick={(e) =>}
              title="Delete My Account"
          >
            Delete My Account
          </Button>
        </div>
      </div>
    </>
  );
};

export default DeleteAccountManagementModel;
